import type { RouteRecordRaw } from 'vue-router';
import { AUTH_ROUTE_NAME } from '@/consts';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const signinRoutes: RouteRecordRaw = {
  path: '/auth/signin',
  component: () => import('@/layouts/public.vue'),
  meta: { i18n },
  children: [
    {
      path: '',
      name: AUTH_ROUTE_NAME.SIGNIN,
      component: () => import('./SignIn.vue'),
      meta: { onlyGuest: true },
    },
  ],
};

export const authRedirects: RouteRecordRaw[] = [
  { path: '/auth', redirect: { name: AUTH_ROUTE_NAME.SIGNIN } },
];
